/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IOnboardingApi {
    getStatus(cancelToken?: CancelToken): AxiosPromise<OnboardingResponse>;
}

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_OnboardingApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_OnboardingApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class OnboardingApi implements IOnboardingApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_OnboardingApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_OnboardingApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    getStatus(cancelToken?: CancelToken): AxiosPromise<OnboardingResponse> {
        let url_ = "/marketing/api/brands/Onboarding";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<OnboardingResponse>(options_);
    }
}

export interface OnboardingResponse {
    state: OnboardingBrandState;
    defaultBrandId?: string | undefined;
    isSmsRegistered: boolean;
}

export enum OnboardingBrandState {
    NotStarted = 0,
    BrandInProgress = 1,
    EmailNotStarted = 2,
    EmailInProgress = 3,
    Completed = 4,
}
